import InterfaceDownloadBox2 from '@streamlinehq/streamlinehq/img/streamline-mini-line/interface-essential/upload-download/interface-download-box-1.svg';
import { BouSvgIcon } from '@upright/ui/common/generic/components/bou-svg-icon';
import styled from 'styled-components';
import { getBouLinkStyle } from '../../../../texts/bou-link';

// Common UI element, shared between multiple table implementations.

export function DownloadAsExcel(props: { onClick: () => void; id?: string; label?: string; disabled?: boolean }) {
  return (
    <Root onClick={props.onClick} id={props.id} disabled={props.disabled ?? false}>
      <Icon />
      {props.label ?? 'Download as Excel'}
    </Root>
  );
}

const Root = styled.button<{ disabled: boolean }>`
  ${props => (!props.disabled ? getBouLinkStyle() : 'cursor: default')};
  white-space: nowrap;
  display: flex;
  align-items: center;
`;

const Icon = styled(BouSvgIcon).attrs({ icon: <InterfaceDownloadBox2 /> })`
  padding-right: 0.6em;
  padding-left: 0.2em;
`;
